<template>
  <div class="page-content">
    <!-- 角色搜索以及添加栏目 -->
    <el-row  class="product-menu" type="flex" justify="end">
      <el-col>
         <el-button type="primary" class="first-btn" @click="addPermission">添加权限</el-button>
      </el-col>
      <el-col :span="6">
        <el-input placeholder="请输入权限名" v-model.trim="permissionName" class="input-with-select" >
          <el-button slot="append" icon="el-icon-search" @click="sel"></el-button>
        </el-input>
      </el-col>
    </el-row>

    <!-- 数据展示区域 -->
    <div class="dataList">
      <el-table
        ref="multipleTable"
        border
        :data="tableData"
        tooltip-effect="dark"
        :cell-style="cellStyle"
        :header-cell-style="headCellStyle"
        style="width: 100%">
        <!-- <el-table-column
         prop="accessId"
          label="权限ID">
        </el-table-column> -->
        <el-table-column
         prop="accessName"
          label="权限名称">
        </el-table-column>
        <!-- <el-table-column
         prop="accessUrl"
          label="权限路径">
        </el-table-column> -->
        <el-table-column
         prop="createTime"
          label="创建时间">
        </el-table-column>
        <el-table-column
         prop="remark"
          label="备注">
        </el-table-column>
        <el-table-column
         prop="createUser"
          label="创建者">
        </el-table-column>
        <el-table-column
          label="操作"
          >
          <template slot-scope="scope">
            <div class="opreationBtn">
              <span class="check" @click="handlerClick('check',scope.row)">查看</span>
              <span class="edit" @click="handlerClick('edit',scope.row)">编辑</span>
              <span class="del" @click="handlerClick('del',scope.row)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页管理 -->
    <paging :total="total" @changePage="changePage"/>
    <!-- 新增用户dialog -->
    <addDialog v-if="addDialogVisible" :addDialogVisible="addDialogVisible" @closeAddDialog="closeAddDialog"/>
    <!-- 编辑用户dialog -->
    <editDialog v-if="editDialogVisible" :editDialogVisible="editDialogVisible" :editData="editData" @closeEditDialog="closeEditDialog" :status="status"/>
  </div>
</template>

<script>
import addDialog from '@/components/permission/addPermissionDialog'
import editDialog from '@/components/permission/editPermissionDialog'
import paging from '@/components/paging'
import { list, deleteAccess } from '@/api/permissionManager'
export default {
  data () {
    return {
      // 分页功能
      total: 0, // 到时候从后台获取
      listQuery: {
        page: 1,
        limit: 10
      },
      // ------------
      tableData: [],
      // checked: false,
      userName: '',
      // 设置表格的样式
      cellStyle: { 'text-align': 'center' },
      headCellStyle: { 'text-align': 'center', 'font-weight': 'bold', 'font-size': '17px', color: 'black', 'background-color': '#f4f5f7' },
      addDialogVisible: false,
      // viewDialogVisible: false,
      // viewData: null,
      editDialogVisible: false, // 编辑或者查看
      editData: null,
      status: false,
      assignDialogVisible: false, // 分配角色
      userId: '',
      permissionName: ''
    }
  },
  components: {
    addDialog,
    editDialog,
    paging
  },
  created () {
    this.getList()
  },
  methods: {
    sel () {
      this.listQuery.page = 1
      this.getList()
    },
    getList () {
      const params = {
        accessName: this.permissionName,
        pageNumber: this.listQuery.page,
        pageSize: this.listQuery.limit
      }
      list(params).then(res => {
        const resData = res.data.data
        this.total = resData.total
        this.tableData = resData.list
        this.tableData.forEach((ele) => {
          if (ele.accessUrl === '' || JSON.stringify(ele.accessUrl) === 'null') ele.accessUrl = '---'
          if (ele.remark === '' || JSON.stringify(ele.remark) === 'null') ele.remark = '---'
        })
      })
    },
    addPermission () {
      this.addDialogVisible = true
    },
    closeAddDialog (val) {
      this.addDialogVisible = false
      if (val) {
        this.getList()
      }
    },
    closeEditDialog (val) {
      this.editDialogVisible = false
      if (val) {
        this.getList()
      }
    },
    closeAssignDialog (val) {
      this.assignDialogVisible = false
      if (val) {
        this.getList()
      }
    },
    handlerClick (sty, row) {
      switch (sty) {
        case 'check':
          this.editDialogVisible = true
          this.status = true
          this.editData = Object.assign({}, row)
          break
        case 'edit':
          this.editDialogVisible = true
          this.status = false
          this.editData = Object.assign({}, row)
          break
        case 'del':
          this.$confirm('确定删除此记录?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            const id = row.accessId
            deleteAccess(id).then((res) => {
              if (res.data.code === 200 || res.data.code === 0) {
                this.$message({
                  type: 'success',
                  message: '删除成功'
                })
                this.getList()
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '删除取消'
            })
          })
          break
        default:
          break
      }
    },
    // 分页管理
    changePage (val) {
      this.listQuery = val
      this.getList()
    }
  }
}
</script>

<style lang="less" scoped>
  .page-content{
     .tap-title{
      margin-bottom: 30px;
      padding-left: 10px;
      display: flex;
      border-left: 5px solid skyblue ;
      font-size: 16px;
    }
    .product-menu{
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      .showOnline{
        margin-right: 20px;
      }
      .is-justify-end{
        align-items: center;
      }
      .left{
        span{
          margin-right: 20px;
          font-size: 20px;
          font-weight: 600;
        }
        .first-btn{
          margin-right: 10px;
        }
        .refalsh{
          margin-right: 20px;
        }
      }

    }

    .dataList{
      background-color: white;
      margin-bottom: 20px;
      .cell{
        text-align: center;
      }
      .opreationBtn{
        .check,.edit{
          color: #35a6df;
          cursor: pointer;
        }
        .del,.stop{
          color: red;
          cursor: pointer;
        }
        span{
          margin-left: 20px;
        }
      }
      .onlineStatus{
        .online{
          color: #138c4b;
        }
        .offline{
          color: red
        }
        span{
          margin-left: 20px;
        }
      }
      .showAll{
        display: flex;
        align-items: center;
        span{
          color: #f0bd95;
        }
      }
      .dataListOperation{
        padding:20px;
      }
    }
}
</style>
